/**
 * leaderboardRanking — iter87.455 (user-requested, no-drift fix).
 *
 * Single source of truth for the ranking-derived rules the full
 * Leaderboard modal (`LeaderboardTable.jsx`) already encodes, so the
 * dashboard Leaderboard tile (`BentoHome.jsx`'s `LeaderboardTickerPreview`)
 * reuses them instead of maintaining a second, driftable copy. Both
 * components read the SAME `board` array (already backend-filtered —
 * see `common.is_active_participant` / `stamp_no_pick_exclusions`), so
 * the only "ranking logic" left to share is (1) podium-mode detection
 * and (2) the "is this rank-1 (or top-3) row actually a leader yet"
 * eligibility guard.
 */

/** TT-ON "podium" (Trophy Tokens Top-3 payout) vs everything else. */
export function isPodiumMode(tournament) {
    const cfg = tournament?.trophy_tokens_config;
    return !!(cfg?.enabled && cfg?.game_type === "podium");
}

/**
 * Mirrors `LeaderboardTable.jsx`'s `podiumEligible` gate exactly: a
 * rank-1 (or top-3 in podium mode) row only gets "leader" treatment
 * once it actually has a positive score — day-1 all-tied-at-0
 * standings have no leader yet, so neither the modal's gold halo/
 * ribbon NOR the tile's "1st" tag should render.
 */
export function isLeaderEligible(row, podiumMode) {
    if (!row) return false;
    return row.total_points > 0 && (podiumMode || row.rank === 1);
}

/** Groups rows into at most `max` bands, one per distinct rank value. */
export function rankBands(rows, max) {
    const seen = [];
    for (const r of rows) {
        let band = seen.find(([rank]) => rank === r.rank);
        if (!band) {
            if (seen.length >= max) continue;
            band = [r.rank, []];
            seen.push(band);
        }
        band[1].push(r);
    }
    return seen.sort((a, b) => a[0] - b[0]);
}
